import styled from '@emotion/styled';
import {
  palette,
  radius,
  shadow,
  spacing,
  transition,
  duration,
  easing,
  layout,
  zIndex,
} from '../../style-utils/theme';
import { down } from '../../style-utils/media-queries';
import { m } from '../../motion';

export const Dropdown = styled.div<{ isDashboard?: boolean }>`
  position: relative;
  ${({ isDashboard }) =>
    isDashboard
      ? `width: 180px; max-width: 100%;`
      : `width: 70%; max-width: 420px;`};

  ${down('sm')} {
    width: 100%;
  }
`;

export const DropdownButton = styled.button<{
  isSelected: boolean;
  isDashboard: boolean;
  isRsuite?: boolean;
  isOpen?: boolean;
}>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: 100%;
  gap: ${spacing.xs};
  background: ${palette.surface};
  border: 1px solid ${palette.line};
  color: ${palette.ink};
  transition: ${transition.colors};
  font: inherit;
  text-align: left;

  ${({ isDashboard, isRsuite }) =>
    isDashboard
      ? isRsuite
        ? `min-height: ${layout.controlHeight}; padding: ${spacing.xs} ${spacing.sm}; border-radius: ${radius.xs};`
        : `min-height: ${layout.controlHeight}; padding: ${spacing.xs} ${spacing.sm}; border-radius: ${radius.pill};`
      : `min-height: ${layout.fieldHeight}; padding: ${spacing.xs} ${spacing.sm}; border-radius: ${radius.xs};`}

  &:hover {
    border-color: ${palette.lineStrong};
    background: ${palette.irisTintSoft};
  }

  &:focus-visible {
    outline: none;
    border-color: ${palette.lagoon};
    box-shadow: ${shadow.focus};
  }

  ${({ isOpen }) =>
    isOpen && `border-color: ${palette.lagoon}; box-shadow: ${shadow.focus};`}
`;

export const OptionsList = m.div<{
  isDashboard?: boolean;
  isRsuite?: boolean;
}>`
  position: absolute;
  top: calc(100% + ${spacing.half});
  left: 0;
  width: 100%;
  background: ${palette.surface};
  border: 1px solid ${palette.line};
  border-radius: ${radius.xs};
  box-shadow: ${shadow.md};
  z-index: ${zIndex.dropdown};
  max-height: 240px;
  overflow-y: auto;
  padding: ${spacing.xs};
  transform-origin: top center;

  ${({ isDashboard, isRsuite }) =>
    isDashboard && isRsuite && `min-width: 170px;`}
`;

export const OptionItem = styled.button<{
  isSelected: boolean;
  isDashboard?: boolean;
  isRsuite?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: ${spacing.xs};
  cursor: pointer;
  overflow: hidden;
  width: 100%;
  border: none;
  background: transparent;
  font: inherit;
  text-align: left;
  color: ${palette.ink};
  padding: ${spacing.xs} ${spacing.sm};
  border-radius: ${radius.xs};
  transition: ${transition.colors};

  ${({ isDashboard }) =>
    isDashboard
      ? `justify-content: flex-start; min-height: ${layout.buttonHeight};`
      : `justify-content: space-between; min-height: ${layout.controlHeight};`}

  ${({ isDashboard, isRsuite }) =>
    isDashboard &&
    isRsuite &&
    `margin-bottom: ${spacing.xs}; min-width: 170px;`}

  ${({ isSelected }) =>
    isSelected &&
    `background: ${palette.irisTint}; color: ${palette.irisDark};`}

  &:hover {
    background: ${palette.irisTintSoft};
  }
  /* KEYBOARD GETS WHAT THE POINTER GETS. This control styled :hover and nothing
     for focus, so it acknowledged a mouse and ignored a keyboard. */
  &:focus-visible {
    outline: none;
    box-shadow: ${shadow.focus};
  }

`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  margin-left: ${spacing.xs};
`;

/** Right-edge cluster on the closed control: selected check + chevron. */
export const TrailingGroup = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.half};
  margin-left: auto;
  flex-shrink: 0;
`;

/** Wraps the chevron so it rotates smoothly when the menu opens. */
export const ChevronWrapper = styled.span<{ isOpen?: boolean }>`
  display: inline-flex;
  align-items: center;
  transition: transform ${duration.base} ${easing.standard};
  transform: rotate(${({ isOpen }) => (isOpen ? '180deg' : '0deg')});
`;
